import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Cta from '../components/Cta';
import Faq from '../components/Faq';
import Hero1 from '../components/Hero1';
import Promo from '../components/Promo';

import Header3 from '../components/Header3';
import Footer3 from '../components/Footer3';
import About2 from '../components/About2';
import Sponsors from '../components/Sponsors';

// import Portfolio2 from '../components/Portfolio2';
import Portfolio4 from '../components/Portfolio4';
import CategoriesCards from '../components/CategoriesCard';
import DealerMap from '../components/Map/Map';
import ProductSlider from '../components/ProductSlider/ProductSlider';
import FacebookFeed from './FacebookFeed';
import InstagramFeed from './InstagramFeed';
import { Helmet } from 'react-helmet';
import BannerBlocks from '../components/BannerBlocks/BannerBlocks';


import '../components/Landing/Landing.css';

import Hero from '../components/Landing/Hero';
import OurProcess from '../components/Landing/OurProcess';
import TrustedBy from '../components/Landing/TrustedBy';
import Solution from '../components/Landing/Solution';
import Innovation from '../components/Landing/Innovation';
import ContactForm from '../components/Landing/ContactForm';
import Footer from '../components/Landing/Footer';

function NewLanding() {

    const heading = "Testfabrics - Your Source for Quality Test Materials, Standard Fabrics, Soiled Fabrics and much more!";
    const pagetitle = heading.length > 160 ? heading.slice(0,57) + '...' : heading;
    

    
    return (
            <>

                <Helmet>
                    <title>{pagetitle}</title>

                </Helmet>
                <Header3 />
                {/* <Hero1 /> */}
                <Promo />
                <About2/>
            <BannerBlocks/>

                <div className='container-fluid qoute-header'>
                    <div className="container d-flex justify-content-center align-items-center">
                        <Link to={'/quote-request'} className="header-btn">Get a Qoute</Link>
                        
                    </div>
                </div>

            <FacebookFeed/>
            {/* <InstagramFeed/> */}
                {/* <Services1 /> */}
                {/* <Cta /> */}
                {/* <Faq /> */}
                {/* <Portfolio4/> */}
                {/* <Portfolio2/> */}
                {/* <CategoriesCards/> */}
                {/* <Sponsors/> */}
            {/* <DealerMap/> */}
            {/* <ProductSlider/>  */}
            
                <Footer3 />

            
            </>
        );


    // return (
    //     <>

    //         <Helmet>
    //             <title>{pagetitle}</title>
    //         </Helmet>
    //         <Header3/>
    //         <Hero/>
    //         <OurProcess/>
    //         <TrustedBy/>
    //         <Solution/>
    //         <Innovation/>
    //         <ContactForm/>
    //         <Footer/>
    //     </>
    // );


}

export default NewLanding;


